import React, { forwardRef, useState, useEffect } from "react";
import { Row, Col } from "antd";
import { DatePickerItem } from "../../../components/forms/FormItems";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { FormattedMessage } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";

const AssociatedCorporation = forwardRef((props, ref) => {
  const [corporations, setCorporations] = useState([]);
  const [currentCorporation, setCurrentCorporation] = useState(null);
  const { activeEmployee, changedValues, changedItems } = props;

  useEffect(() => {
    if (activeEmployee && activeEmployee.foreign && corporations.length > 0) {
      const corporationId = changedItems.includes(
        "foreign.current_corporation_id"
      )
        ? changedValues["foreign.current_corporation_id"]
        : activeEmployee.foreign.current_corporation_id;
      const filtered =
        corporationId && corporations.filter((i) => i.id === corporationId)[0];
      setCurrentCorporation(filtered);
    }
  }, [corporations, activeEmployee, changedValues, changedItems]);
  const onDataChanged = (list) => {
    setCorporations(list);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.associatedCorporation" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="foreign.current_corporation_id"
                  category="employee"
                  metadataName="foreign_corporations"
                  onDataChanged={onDataChanged}
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="foreign.current_corporation_registry_date"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>
            {currentCorporation && (
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <ReadOnlyItem
                    content={
                      currentCorporation && currentCorporation.contact_name
                    }
                    name="foreign.corporation_contact_name"
                    category="employee"
                  />
                </div>
                <Spacer horizontal={true} />

                <div style={{ flex: 1 }}>
                  <ReadOnlyItem
                    content={
                      currentCorporation &&
                      currentCorporation.contact_phone_number
                    }
                    name="foreign.corporation_contact_phone"
                    category="employee"
                  />
                </div>
              </ResponsiveItemsWrapper>
            )}

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="foreign.previous_corporation_id"
                  category="employee"
                  metadataName="foreign_corporations"
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="foreign.registered_in_employer_service"
                  category="employee"
                  trueFalse={true}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default AssociatedCorporation;
